<a href="#main-content" class="skip-link">Skip to main content</a>
<ic-header *ngIf="clientConfig"></ic-header>
<p-toast [baseZIndex]="999999"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle" rejectButtonStyleClass="p-button-text"
    closeAriaLabel="Close" ariaLabel="Confirmation">
</p-confirmDialog>
<ngx-ui-loader fgsSize="50" fgsColor="{{clientConfig?.color}}" pbThickness="4" pbColor="{{clientConfig?.color}}">
</ngx-ui-loader>
<div *ngIf="!isInternetActive" role="alert" aria-live="assertive" style="text-align: center;">
    <img style="height:50px; width:50px" src="../assets/images/wifi.png" alt="Wifi Not Connected" />
    <h5>No Internet Connection</h5>
</div>
<main id="main-content" role="main" tabindex="-1">
    <router-outlet></router-outlet>
</main>